module.exports = __webpack_public_path__ + "img/1579713309.cc35834c.jpg";